<template>
  <div>
    <Card :title="title || '保单基本信息'">
      
      <Form :label-width="125" class="mt15">
        <Row>
          <!-- 保单 -->
          <template v-if="type == 'policy'">
            <Col span="12">
              <FormItem label="保障状态：">
                {{ info.statusName }}
              </FormItem>
            </Col>
            <Col span="12" >
              <FormItem label="保障凭证号：">
               {{ info.policyNo }}
              </FormItem>
            </Col>
            <Col span="12" >
              <FormItem label="保单号：">
                <span>{{info.policyScrip}}</span>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="投保公司：">
                {{ info.centerName }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="联系方式：">
                {{ info.phone }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="被保公司：">
                {{ info.companyListString }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="投保单号：">
                <a
                  :href="'#/my/customizedTPL/insuranceDetail/' + info.billNo"
                  target="_blank"
                  rel="opener"
                  >{{ info.billNo }}</a>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="保单创建时间：">
                {{ info.updateTime }}
              </FormItem>
            </Col>
            <Col span="12">
              <!-- 月单不允许下载 年单允许下载 工单号XQ-2824 -->
              <FormItem label="保单附件：" v-if="info.policyTimeType==1">
                <!-- <div v-for="(item,index) in imgList" :key="index" style="word-wrap:break-word; word-break:break-all;">
                  {{ item }} -->
                  <a :href="info.url" target="_blank" rel="opener" class="ml15">查看</a>
                <!-- </div> -->
              </FormItem>
            </Col>
          </template>
          <!-- 投保单 -->
          <template v-if="type == 'insurance'">
            <Col span="12">
              <FormItem label="投保单状态：">
                {{ info.statusName }}
              </FormItem>
            </Col>
            <Col span="12" >
              <FormItem label="投保单号：">
                <span>{{ info.billNo }}</span>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="投保单创建时间：">
                {{ info.createTime }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="投保公司：">
                {{ info.centerName }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="联系电话：">
                {{ info.phone }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="被保公司：">
                {{ info.companyListString }}
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="保障凭证号：">
                <a :href="'#/my/customizedTPL/policyDetail/'+(info.policyNo)" target="_blank" rel="opener" class="lineFeed">{{ info.policyNo }}</a>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="投保单附件：">
                <div v-for="(item,index) in imgList" :key="index" style="word-wrap:break-word; word-break:break-all;">
                  {{ item }}
                  <a :href="item" target="_blank" rel="opener" class="ml15">查看</a>
                </div>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="审核备注：">
                {{ info.remark }}
              </FormItem>
            </Col>
          </template>
        </Row>
      </Form>
    </Card>
    <Modal
        v-model="modal"
        title="历史投保单（盖章 ）"
		:mask-closable="false"
		width="60%">
          <Table border :columns="columns" :data="info.fileList">
              <template slot-scope="{ row }" slot="action">
				<a :href="row.fileUrl" rel="opener" target="_blank">查看</a>
              </template>
          </Table>
		  <div slot="footer">

		  </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default() {
        return {};
      }
    },
    title: String,
    type: {
      type: String,
      default() {
        return "policy";
      }
    }
  },
  data(){
    return {
      modal: false,
			columns:[
				{title:'操作时间',key:'createTime'},
				{title:'文件名',key:'fileName'},
				{title:'操作',slot: 'action'},
			]
    }
  },
  computed:{
		imgList(){
			return this.info.attachmentUrl?this.info.attachmentUrl.split(','):[]
		}
	},
  methods: {
    ok(){

    },
    cancel(){

    },
    showImg(){
			this.modal = true;
		}
  }
};
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedForklift/common/PolicyBasicInfo.vue